import styled from 'styled-components';

export const Container = styled.div`
  .commentary-content {
    user-select: text;
  }
`;
